module.exports = __webpack_public_path__ + "media/images/icons/scroll_right_navigation-350b77dedc244e7d81005adaa5011c0f.svg";